export default __webpack_public_path__ + "static/media/apollo-logo-tm-white.5747b87f.png";